module.exports = __webpack_public_path__ + "img/building_clouds.3f53809.webp";